<div class="container animated fadeInRight">
  <app-lfsa-card [innTemplate]="puntoEntrega" [titulo]="'Usuarios que pueden Marcar Visalud'" [efecto]="true" [colapseName]="'puntoEntrega'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #puntoEntrega>
    <div class="row">
      <div [class]="'form-group col-md-8'">
        <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
          (keyup)="onQuickFilterChanged()" #quickFilter />
      </div>
      <div [class]="'form-group col-md-4'">
        <button class="btn btn-success btn-block" (click)="callModal()">Agregar</button>
      </div>
    </div>
    <br>
    <hr>
    <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
    <div *ngIf="!loading">
      <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
        No existen datos para la lista de cargos.
      </div>
      <ag-grid-angular *ngIf="!listaVacia" #agGrid class=" {{empModulo.agGrid.class}}"
        [ngStyle]="empModulo.agGrid.style" id="{{empModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents "
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)"
        [pagination]="true" [paginationPageSize]=15>
      </ag-grid-angular>
    </div>
    <br>
  </ng-template>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/home-emp']" class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
    </div>
  </div>
</div>
<br>
<!-- MODAL -->
<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="titulo" [idButton]="'abrirModal'"
  [idOpen]="'Modal'" [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <form [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [mostrarImg]="false" (keyup)="onKeydown($event)"
          [rutaImagen]="" [control]="formulario.get('descripcion')"
          [placeholder]="'Cedula'" formControlName="descripcion" [label]="'Cedula*'" [type]="'text'"
          [id]="'descripcion'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [isReadOnly] = "true" [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('codigo')"
          [placeholder]="'Nombre del Usuario'" formControlName="codigo" [label]="'Nombre del Usuario'" [type]="'text'"
          [id]="'codigo'">
        </app-lfsa-input>
      </div>
     
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button *ngIf="!banderaEdit" class="btn btn-success btn-block" [disabled]="formulario.invalid" (click)="agregarPuntoEntrega()">Guardar</button>
          <button *ngIf="banderaEdit" class="btn btn-success btn-block" [disabled]="formulario.invalid" (click)="editarPuntoEntrega()">Editar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>